
import EditItemSelect from '@/components/edit/EditItemSelect';

export default {
    extends: EditItemSelect,
};
